import { ChatBotUIConversationMessage } from "@jugl-web/domain-resources/chat-bot";

export const PREVIEW_USER_NAME = "James Kenter";
export const WELCOME_MESSAGE_ID = "welcome";

export const CONTAINER_PADDING = 48;
export const BUTTON_SIZE = 72;
export const VECTOR_THICKNESS = 8;

export const MOCKED_OUTGOING_MESSAGE: ChatBotUIConversationMessage = {
  id: "test",
  type: "outgoing",
  timestamp: new Date(),
  payload: {
    type: "text",
    text: "Hello! I would like to know more about your services",
    quickReplies: [],
  },
  senderName: PREVIEW_USER_NAME,
  senderImageUrl: "",
};

export const INITIAL_INCOMING_MESSAGE: ChatBotUIConversationMessage = {
  id: WELCOME_MESSAGE_ID,
  type: "incoming",
  timestamp: new Date(),
  payload: { type: "text", text: "", quickReplies: [] },
  senderName: "",
  senderImageUrl: "",
};
